<template>
    <div
        class="index"
        v-loading.fullscreen="showLoading"
        element-loading-text="加载中..."
    >
        <div class="banner">
            <banner-swiper></banner-swiper>
            <div class="content start-wrap">
                <button class="start" @click="start()">开始备案</button>
            </div>
        </div>
        <div class="page fun">
            <div class="content">
                <ul class="fun-list flex flex-wrap">
                    <li class="fun-item flex items-center">
                        <img
                            src="@/assets/images/fun_01.png"
                            alt="个性备案功能定制"
                        />
                        <div>
                            <h4>个性备案功能定制</h4>
                            <p>满足不同客户的需求</p>
                        </div>
                    </li>
                    <li class="fun-item flex items-center">
                        <img
                            src="@/assets/images/fun_02.png"
                            alt="保障数据安全"
                        />
                        <div>
                            <h4>保障数据安全</h4>
                            <p>隐私数据加密存储和传输</p>
                        </div>
                    </li>
                    <li class="fun-item flex items-center">
                        <img
                            src="@/assets/images/fun_03.png"
                            alt="引导式备案流程"
                        />
                        <div>
                            <h4>引导式备案流程</h4>
                            <p>自动判断备案类型</p>
                        </div>
                    </li>
                    <li class="fun-item flex items-center">
                        <img
                            src="@/assets/images/fun_04.png"
                            alt="符合工信部标准"
                        />
                        <div>
                            <h4>符合工信部标准</h4>
                            <p>功能丰富可靠</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="page flow">
            <!-- <Motion
                :initial="{ opacity: 0, y: 200 }"
                :inView="{ opacity: 1, y: 0 }"
                :transition="{ duration: 1, delay: 0.3 }"
                class="fade-section"
            > -->
            <div class="title">
                <h3>备案流程</h3>
                <p>Filing process</p>
            </div>
            <!-- </Motion> -->
            <div class="flow-content">
                <div class="content">
                    <!-- <Motion
                        :initial="{ opacity: 0, y: 200 }"
                        :inView="{ opacity: 1, y: 0 }"
                        :transition="{ duration: 1, delay: 0.2 }"
                        class="fade-section"
                    > -->
                    <nav>
                        <ul class="flow-list flex items-center">
                            <li
                                :class="[
                                    'flow-item flex items-center flex-col justify-center',
                                    {
                                        'flow-item-activate':
                                            currentFlow == index
                                    }
                                ]"
                                v-for="(item, index) in flowList"
                                :key="index"
                                @click="currentFlow = index"
                            >
                                <h4>{{ item.title }}</h4>
                                <p>{{ item.sub_title }}</p>
                            </li>
                        </ul>
                    </nav>
                    <!-- </Motion> -->
                    <div>
                        <div
                            class="mobile-sub_title text-danger"
                            v-for="(item, index) in flowList"
                            :key="index"
                            v-show="currentFlow == index"
                        >
                            <em>*</em> {{ item.sub_title }}
                        </div>
                        <img
                            src="@/assets/images/beian.png"
                            alt="备案流程"
                            class="flow-img"
                        />
                        <ul class="flow-content-list flex">
                            <template
                                v-for="(flow, index) in flowList"
                                :key="index"
                            >
                                <li
                                    class="flow-content-item"
                                    v-for="(item, line_index) in flow.flow"
                                    :key="line_index"
                                    v-show="currentFlow == index"
                                >
                                    <div
                                        class="flow-content-line-item flex items-center"
                                        v-for="(flow_item, item_index) in item"
                                        :key="item_index"
                                    >
                                        <em class="dot"></em>
                                        <p>
                                            {{ flow_item }}
                                        </p>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="page rules">
            <!-- <Motion
                :initial="{ opacity: 0, y: 200 }"
                :inView="{ opacity: 1, y: 0 }"
                :transition="{ duration: 1, delay: 0.3 }"
                class="fade-section"
            > -->
            <div class="title">
                <h3>各省备案规则</h3>
                <p>Provincial filing rules</p>
            </div>
            <!-- </Motion> -->
            <div class="rules-content">
                <div class="content">
                    <p>*请选择下方地图中您备案所在的省份，查看具体的备案规则</p>
                    <div class="flex flex-wrap justify-center">
                        <div class="rule-map">
                            <!-- <Motion
                                :initial="{ opacity: 0, scale: 0 }"
                                :inView="{ opacity: 1, scale: 1 }"
                                :transition="{ duration: 1, delay: 0.2 }"
                                class="fade-section"
                            > -->
                            <filing-rules
                                @clicks="provinceHandler"
                            ></filing-rules>
                            <!-- </Motion> -->
                        </div>
                        <div class="rule-right">
                            <p class="rule-title">
                                {{ region.province_name }}备案规则
                            </p>
                            <!-- <Motion
                                :initial="{ opacity: 0, scale: 0 }"
                                :inView="{ opacity: 1, scale: 1 }"
                                :transition="{ duration: 1, delay: 0.2 }"
                                class="fade-section"
                            > -->
                            <ul class="rule-type-list flex">
                                <li
                                    :class="[
                                        'rule-type-item',
                                        {
                                            'rule-type-item-activate':
                                                index == currentRuleType
                                        }
                                    ]"
                                    v-for="(ruleType, index) in ruleTypeList"
                                    :key="index"
                                    @click="currentRuleType = index"
                                >
                                    {{ ruleType.name }}
                                </li>
                            </ul>
                            <div class="rule-html minimal-scroll">
                                <div
                                    v-html="ruleTypeList[currentRuleType].desc"
                                ></div>
                            </div>
                            <!-- </Motion> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page guidance">
            <!-- <Motion
                :initial="{ opacity: 0, y: 200 }"
                :inView="{ opacity: 1, y: 0 }"
                :transition="{ duration: 1, delay: 0.3 }"
                class="fade-section"
            > -->
            <div class="title">
                <h3>备案指导</h3>
                <p>Record guidance</p>
            </div>
            <!-- </Motion> -->

            <div class="guidance-content">
                <ul class="content flex justify-between flex-wrap">
                    <li
                        class="guidance-card-item"
                        v-for="(cardItem, cardIndex) in guidanceList"
                        :key="cardIndex"
                    >
                        <!-- <Motion
                            :initial="{ opacity: 0, y: 200 }"
                            :inView="{ opacity: 1, y: 0 }"
                            :transition="{
                                duration: 1,
                                delay: 0.1 * (cardIndex + 1)
                            }"
                            class="fade-section"
                        > -->
                        <router-link
                            :to="cardItem.route"
                            class="guidance-card-header flex items-center justify-between"
                        >
                            <div class="flex">
                                <img
                                    :src="cardItem.icon"
                                    :alt="cardItem.name"
                                />
                                <h4>{{ cardItem.name }}</h4>
                            </div>
                            <img src="@/assets/images/right.png" alt="更多" />
                        </router-link>
                        <div class="guidance-list">
                            <router-link
                                :to="'/index/details_all?id=' + article.id"
                                class="guidance-list-item"
                                v-for="(
                                    article, articleIndex
                                ) in cardItem.articleList"
                                :key="articleIndex"
                            >
                                <div class="link">
                                    {{ article.title }}
                                </div>
                                <em>{{ article.create_time }}</em>
                            </router-link>
                        </div>
                        <!-- </Motion> -->
                    </li>
                </ul>
            </div>
        </div>

        <div class="custom-footer-wrap">
            <layout-footer v-if="appStore.showFooter" />
        </div>
    </div>
</template>
<script setup lang="ts">
import { getAddressRuleInfo } from '@/api/newarticle'
import { getTypeArticle } from '@/api/newarticle'
import useAppStore from '@/stores/modules/app'
import LayoutFooter from '@/layout/default/components/footer/index.vue'
import { Motion } from '@motionone/vue'
import { useRouter } from 'vue-router'
import feedback from '@/utils/feedback'
const router = useRouter()
const appStore = useAppStore()

const showLoading = shallowRef(false)
const currentFlow = shallowRef(0)
const flowList = readonly([
    {
        icon: new URL('@/assets/images/fun_01.png', import.meta.url),
        title: '新增备案',
        sub_title: '主办者和域名均从未进行过备案',
        flow: [
            ['验证网站域名', '验证主办单位证件号'],
            ['填写主办单位信息', '填写网站信息', '核验身份']
        ]
    },
    {
        icon: new URL('@/assets/images/fun_02.png', import.meta.url),
        title: '新增网站',
        sub_title: '主办者已备案，新增一个未备案的域名网站',
        flow: [
            ['验证网站域名', '验证主办单位证件号'],
            ['填写主办单位信息', '核验身份']
        ]
    },
    {
        icon: new URL('@/assets/images/fun_03.png', import.meta.url),
        title: '新增接入',
        sub_title: '已在其他服务接入商备案',
        flow: [
            ['验证网站域名', '验证主办单位证件号', '验证备案号'],
            ['填写主办单位信息', '填写网站信息', '核验身份']
        ]
    }
])

const region = reactive({
    province_name: '',
    province_value: 110000
})

type Rule = {
    person_desc: string
    enterprise_desc: string
}

const rulesList = ref<Rule[]>([])

const ruleTypeList = reactive([
    {
        name: '企业用户',
        desc: ''
    },
    {
        name: '个人用户',
        desc: ''
    }
])
const currentRuleType = ref(0)

// 更新规则
const provinceHandler = (event: any) => {
    const { name, value } = event
    region.province_name = name
    region.province_value = value
    const index = getRulesIndex()
    if (~index) {
        ruleTypeList[0].desc = rulesList.value[index].enterprise_desc
        ruleTypeList[1].desc = rulesList.value[index].person_desc
    } else {
        ruleTypeList[0].desc = ''
        ruleTypeList[1].desc = ''
    }
}

// 获取规则
const getAddressRuleInfoFun = () => {
    getAddressRuleInfo().then((data: any) => {
        rulesList.value = data
        defaultRules()
    })
}
getAddressRuleInfoFun()

// 设置默认规则
const defaultRules = () => {
    provinceHandler({ name: '北京市', value: 110000 })
}

// 查找规则
const getRulesIndex = () => {
    const index = rulesList.value.findIndex((item: any) => {
        return item.province_id == region.province_value
    })
    return index
}

const guidanceList = ref<any[]>([
    {
        route: '/index/filing_flow',
        name: '备案流程',
        icon: new URL('@/assets/images/guidance_01.png', import.meta.url),
        articleList: []
    },
    {
        route: '/index/laws_regulations',
        name: '法律法规',
        icon: new URL('@/assets/images/guidance_02.png', import.meta.url),
        articleList: []
    },
    {
        route: '/index/system_help',
        name: '系统帮助',
        icon: new URL('@/assets/images/guidance_03.png', import.meta.url),
        articleList: []
    },
    {
        route: '/index/latest_notice',
        name: '最新公告',
        icon: new URL('@/assets/images/guidance_04.png', import.meta.url),
        articleList: []
    }
])

const getTypeArticleFun = (): void => {
    getTypeArticle().then((data) => {
        const law = data[3].slice(0, 5)
        const flow = data[4].slice(0, 5)
        const announcement = data[5].slice(0, 5)
        const help = data[6].slice(0, 5)

        guidanceList.value[0].articleList = flow
        guidanceList.value[1].articleList = announcement
        guidanceList.value[2].articleList = help
        guidanceList.value[3].articleList = law
    })
}
getTypeArticleFun()

appStore
    .getIcpConfig()
    .then(() => {
        const t = setTimeout(() => {
            showLoading.value = false
            clearTimeout(t)
        }, 1000)
    })
    .catch(() => {
        feedback.msgError('获取数据失败，请刷新页面重试!')
    })
const start = () => {
    router.push('/login')
}
</script>
<style lang="scss" scoped>
.index {
    background-color: #fff;
}
.page {
    // background-color: #f5f5f5;
    // padding: 0 30px;
}
.content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 30px;
}

.banner {
    .start-wrap {
        position: relative;
        z-index: 100;
        .start {
            position: absolute;
            bottom: 150px;
            left: 0;
            padding: 10px 40px;
            background-color: #fff;
            text-align: center;
            color: #0c28df;
            border-radius: 5px;
            z-index: 1000;
        }
    }
}
.fun {
    position: relative;
    z-index: 100;
    // background-color: #fff;
    margin-top: -50px;
    .fun-item {
        flex: 1;
        flex-shrink: 0;
        background-color: #fff;
        box-shadow: 0 2px 8px 0 rgba(11, 38, 222, 0.25);
        height: 92px;
        border-radius: 4px;
        padding: 0 30px;
        &:not(:last-child) {
            margin-right: 20px;
        }
        h4 {
            font-size: 18px;
            color: #1c1c1c;
        }
        p {
            font-size: 14px;
            color: #7a7a7a;
        }
        img {
            margin-right: 10px;
        }
    }
}
.title {
    text-align: center;
    padding: 60px 0;
    background-color: #f5f5f5;
    h3 {
        font-size: 36px;
        color: #1c1c1c;
    }
    p {
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
    }
}

.flow {
    background-color: #fff;
    .mobile-sub_title {
        display: none;
        font-size: 12px;
        padding-top: 16px;
    }
    .title {
        background-color: #fff;
    }
    .flow-content {
        padding-bottom: 30px;
    }
    .flow-item {
        flex: 1;
        flex-shrink: 0;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
        background: rgba(255, 255, 255, 1);
        height: 120px;
        cursor: pointer;
        h4 {
            font-size: 24px;
            color: #000000;
        }
        p {
            font-size: 14px;
            color: #666666;
        }
        &:first-child {
            border-radius: 12px 0px 0px 12px;
        }
        &:last-child {
            border-radius: 0px 12px 12px 0px;
        }
        transition: all 0.3s;
    }
    .flow-item-activate {
        background-color: #0b61d2;
        h4,
        p {
            color: #fff;
        }
    }

    .flow-content-item {
        padding-right: 30px;
        font-size: 16px;

        .dot {
            display: inline-block;
            width: 6px;
            height: 6px;
            background-color: #0b61d2;
            margin-right: 20px;
        }
        .flow-content-line-item {
            padding-bottom: 10px;
        }
    }
    .flow-img {
        margin: 110px 0 30px;
    }
}

.rules {
    .rules-content {
        background-color: #fff;
        padding: 30px 0;
    }
    .rule-map {
        width: 66%;
        flex-shrink: 0;
    }
    .rule-right {
        width: 34%;
        flex-shrink: 0;
    }
    .rule-title {
        padding-bottom: 20px;
        font-size: 18px;
    }
    .rule-type-list {
        border: 1px solid #0b61d2;
        cursor: pointer;
    }
    .rule-type-item {
        flex: 1;
        flex-shrink: 0;
        font-size: 14px;
        text-align: center;
        padding: 6px 0;
    }
    .rule-type-item-activate {
        background-color: #0b61d2;
        color: #fff;
    }
    .rule-html {
        max-height: 800px;
        overflow-y: auto;
        padding: 20px;
    }
}

.guidance {
    background-color: #f5f5f5;
    padding-bottom: 100px;
    .guidance-card-item {
        width: 24%;
        flex: 1;
        flex-shrink: 0;
        border-radius: 10px;
        padding-bottom: 20px;
        background-color: #fff;
        &:not(:last-child) {
            margin-right: 1.3333333%;
        }
        cursor: pointer;
    }
    .guidance-card-header {
        background-color: #0b61d2;
        padding: 20px 24px;
        color: #fff;
        font-size: 20px;
        border-radius: 10px 10px 0 0;
        img {
            object-fit: contain;
        }
        h4 {
            padding-left: 10px;
        }
    }
    .guidance-list {
        padding: 0 20px;
    }
    .guidance-list-item {
        display: block;
        padding: 14px 0;
        border-bottom: 1px dashed #c1c2c2;
        color: #333;
        font-size: 16px;
        &:hover {
            color: #0b61d2;
            font-weight: 700;
            em {
                color: #0b61d2;
                font-weight: 400;
            }
        }
        em {
            display: block;
            color: #666;
            font-size: 12px;
            font-style: normal;
            padding: 6px 0 0;
        }
        .link {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            height: 48px;
        }
    }
}
@media (max-width: 1260px) {
    .banner {
        .start-wrap {
            .start {
                left: 30px;
            }
        }
    }
}
@media (max-width: 1200px) {
    .fun {
        .fun-item {
            padding: 0 16px;
            height: 82px;
            h4 {
                font-size: 16px;
            }
        }
    }

    .rules {
        .rule-html {
            height: 700px;
        }
    }
}
@media (max-width: 992px) {
    .fun {
        .fun-item {
            width: 49%;
            flex: 0 1 auto;
            padding: 0 30px;
            height: 92px;
            margin: 0 0 2% 0 !important;
            &:nth-child(2n - 1) {
                margin-right: 2% !important;
            }
        }
    }
    .flow {
        .flow-img {
            margin-top: 60px;
        }
        .flow-item {
            h4 {
                font-size: 20px;
            }
            p {
                font-size: 12px;
            }
        }
    }
    .guidance {
        .guidance-card-item {
            width: 49%;
            flex: 0 1 auto;
            margin: 0 0 2% 0 !important;
            &:nth-child(2n - 1) {
                margin-right: 2% !important;
            }
        }
    }
    .rules {
        .rule-html {
            height: 500px;
        }
    }
}

@media (max-width: 768px) {
    .title {
        font-size: 28px;
    }
    .content {
        padding: 0 20px;
    }
    .fun {
        .fun-item {
            width: 98%;
            height: auto;
            flex: 0 1 auto;
            padding: 20px 30px;
            margin: 0 0 2% 0 !important;
            &:nth-child(2n - 1) {
                margin-right: 2% !important;
            }
        }
    }
    .flow {
        .mobile-sub_title {
            display: block;
        }
        .flow-img {
            margin-top: 20px;
        }
        .flow-item {
            height: 0;
            padding: 20px 0;
            h4 {
                font-size: 16px;
            }
            p {
                font-size: 12px;
                display: none;
            }
        }
    }
    .rules {
        .rule-map {
            width: 100%;
            flex-shrink: 0;
        }
        .rule-right {
            width: 100%;
            flex-shrink: 0;
        }
        .rule-html {
            height: 400px;
        }
    }
    .guidance {
        .guidance-card-item {
            width: 49%;
            flex: 0 1 auto;
            margin: 0 0 2% 0 !important;
            &:nth-child(2n - 1) {
                margin-right: 2% !important;
            }
        }
    }
}
@media (max-width: 576px) {
    .guidance {
        .guidance-card-item {
            width: 100%;
            margin: 0 0 20px 0 !important;
            &:nth-child(2n - 1) {
                margin-right: 0 !important;
            }
        }
    }
}
</style>
